const errorConstants =
{
    "CANNOT_DELETE": "Cannot delete due to multiple customizations , delete from the cart",
};


export default Object.freeze( errorConstants );